import React from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import {
  FlexGrid,
  FlexGridCellTemplate,
  FlexGridColumn,
} from '@mescius/wijmo.react.grid';
import * as wjGrid from '@mescius/wijmo.grid';
import { CollectionView } from '@mescius/wijmo';

import { ConferencePageHeader } from '../components/PageHeader';
import {
  API_FLAG,
  HEADER_CONSTANTS,
  PARTNER_APPROVAL_NAME,
  SCHEDULE_STATUS,
  TAB_KEY_STATUS,
  WORK_LIST_FIRST_3_ITEMS,
} from '../utilities/constants';
import WorkScheduleService from '../services/Works';
import { messageUtility } from '../utilities/messageUtility';
import FieldService from '../services/Fields';
import dialogLoader from '../utilities/dialogLoader';
import { CloseEditView } from '../components/CloseEditView';
import { Confirmation } from '../components/modals/common';
import SessionStorageService from '../services/utilities/SessionStorageService';
import urlParamManger from '../utilities/urlParamManager';
import { WorkResult, WorkSchedule } from '../components/pageComponents';
import { FormInformationDialog } from '../components/FormInformationDialog';
import HeaderTemplate from '../components/wijimo/templates/HeaderTemplate';
import PartnerCompanyTemplate from '../components/wijimo/templates/PartnerCompanyTemplate';
import JobTemplate from '../components/wijimo/templates/JobTemplate';
import ForemanTemplate from '../components/wijimo/templates/ForemanTemplate';
import OptionTemplate from '../components/wijimo/templates/OptionTemplate';
import InputTemplate from '../components/wijimo/templates/InputTemplate';
import ManagerUserTemplate from '../components/wijimo/templates/ManagerUserTemplate';
import { validationByJoi } from '../utilities/commonValidation';
import ContentTemplate from '../components/wijimo/templates/ContentTemplate';
import KeyPlanTemplate from '../components/wijimo/templates/KeyPlanTemplate';
import FieldItemTemplate from '../components/wijimo/templates/FieldItemTemplate';
import HeaderRowTemplate from '../components/wijimo/templates/HeaderRowTemplate';
import GroupsTemplate from '../components/wijimo/templates/GroupsTemplate';
import WorkDayWorkerTemplate from '../components/wijimo/templates/WorkDayWorkerTemplate';
import WorkDateTemplate from '../components/wijimo/templates/WorkDateTemplate';
import { isApiFlagOn } from '../utilities/commonUtil';
import Loader from '../components/Loader';
import { workMultipleEditSchema } from '../utilities/validationSchemas/workMultipleEdit';
import OxygenLackTemplate from '../components/wijimo/templates/OxygenLackTemplate';
import HotWorkTemplate from '../components/wijimo/templates/HotWorkTemplate';
import EventMg, { EventType } from '../utilities/EventManager';
import ProgressService from '../services/Progress';
import moment from 'moment';
import { isDuplicateTransmissionError } from '../utilities/apiErrorMessage';

const FIXED_ITEM_MAX_LENGTH = 255;
const ITEM_MAX_LENGTH = 31;

export class WorkBatchEdit extends React.Component {
  constructor(props) {
    super(props);

    const { isWorkSchedule, loadPage } = this.props;
    this.isBatchUpdating = false;
    this.companyBranchId = parseInt(
      SessionStorageService.getItem('company_branch_id'),
      10
    );

    this.state = {
      scheduleFlag: isWorkSchedule
        ? SCHEDULE_STATUS.schedule.id
        : SCHEDULE_STATUS.result.id,
      currentWorkTotal: 0,
      isLoading: true,
      usePartnerCompanyApprovalFlag:
        SessionStorageService.getUsePartnerCompanyApprovalFlag() ===
        API_FLAG.On,
      partnerApprovalName: isWorkSchedule
        ? PARTNER_APPROVAL_NAME.schedule
        : PARTNER_APPROVAL_NAME.result,
      fieldId: SessionStorageService.getFieldId(),
      errorMessage: {},
      formValues: [],
      isVisibleUpdateModal: false,
      errorModalMessage: '',
      selectedWorkIds: _.chunk(
        SessionStorageService.getSelectedBatchWorkListIds().map(Number),
        30
      ),
      offset: 0,
      allLoaded: false,
      selectedPrivateWorkIds: SessionStorageService.getPrivateBatchWorkListIds().map(
        Number
      ),
      progressDateFrom: null,
      progressDateTo: null,
      lengthOfListMainWorkTypes: 0,
      columnHeader: [],
      fieldItems: null,
      itemChanged: [],
      workCollectionView: new CollectionView(),
      messageValidate: [],
      showWorkDayworkersUnSolvableErrorMessage: null,
      tempWorkGroupImages: [],
      currentWorkGroupIdSelected: null,
      currentWorkIdSelected: null,
      workTime: {},
      pinnedColumn: 0,
      tabKeyStatus: TAB_KEY_STATUS.enabled,
    };
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          const { vw, param } = this.props;
          const PageComponent = isWorkSchedule ? WorkSchedule : WorkResult;
          const pageUrl = isWorkSchedule ? 'WorkSchedule' : 'WorkResult';
          dialogLoader.close();
          loadPage(PageComponent, param);
          urlParamManger.setPage(pageUrl, vw);
        },
      },
    };
    this.currentError = {};
    this.grid = null;
    this.optionListNumbers = _.times(20, i => `option${i + 1}`);
    this.optionMustFlag = {};
    this.isSubmittingFlag = false;
    this.isLoading = false;
    this.workSchema = workMultipleEditSchema;
  }

  async componentDidMount() {
    this.handleProgressFieldSetting();
    this.toggleConferenceMode();
    await this.handleSetColumnHeader();
    this.initWorkCollectionView();
  }

  /**
   * Get info progress setting for show main work , sub work
   */
  handleProgressFieldSetting = () => {
    const { fieldId } = this.state;
    return Promise.all([
      ProgressService.getProgressFieldSettings(fieldId),
      ProgressService.getProgressFieldMainWorkTypes(fieldId, {
        limit: 1,
        include_other_flag: 1,
      }),
    ]).then(response => {
      const [responseFieldSettings, responseFieldMainWork] = response;
      this.setState({
        progressDateFrom: _.get(
          responseFieldSettings,
          'data.entities.progress_field_settings.input_start_date',
          null
        ),
        progressDateTo: _.get(
          responseFieldSettings,
          'data.entities.progress_field_settings.input_end_date',
          null
        ),
        lengthOfListMainWorkTypes: _.get(
          responseFieldMainWork.data,
          'total',
          0
        ),
      });
    });
  };

  toggleConferenceMode = (isConferenceMode = true) => {
    EventMg.trigger(EventType.CONFERENCE_MODE, isConferenceMode);
  };

  handleSetColumnHeader = async () => {
    const { fieldId, scheduleFlag } = this.state;
    return Promise.all([
      FieldService.workColumnsSettings(fieldId, {
        schedule_flag: scheduleFlag,
      }),
      FieldService.info(fieldId),
    ]).then(response => {
      const [responseColumnSetting, responseFieldInfo] = response;
      if (responseColumnSetting.result && responseFieldInfo.result) {
        const fieldInfo = _.get(responseFieldInfo, 'data.entities.field', []);
        const fieldItems = _.get(fieldInfo, 'field_items');
        fieldItems.oxygen_lack_print_flag = _.get(
          fieldInfo,
          'oxygen_lack_print_flag',
          0
        );

        let columnHeader = _.filter(
          _.get(
            responseColumnSetting,
            'data.entities.work_columns_settings.edit_multiple_order'
          ),
          header => header.display
        );
        columnHeader = _.sortBy(columnHeader, item => item.order_number);
        const oxygenIndex = columnHeader.findIndex(
          column => column.type === 'oxygen_lack'
        );
        if (oxygenIndex !== -1) {
          columnHeader[
            oxygenIndex
          ].display = !!fieldItems.oxygen_lack_print_flag;
        }
        _.forEach(columnHeader, column => {
          if (this.optionListNumbers.includes(column.type)) {
            column.display = !!fieldItems[`${column.type}_display_flag`];
          }
        });
        const workPlaceIndex = columnHeader.findIndex(
          item => item.type === 'work_place'
        );
        if (workPlaceIndex !== -1) {
          const workPlace = [
            {
              type: 'work_place_a',
              name: _.get(fieldItems, 'field_item_list1_title'),
              display: !!_.get(fieldItems, 'field_item_list1_display_flag'),
              index: 1,
              key: 'a',
            },
            {
              type: 'work_place_b',
              name: _.get(fieldItems, 'field_item_list2_title'),
              display: !!_.get(fieldItems, 'field_item_list2_display_flag'),
              index: 2,
              key: 'b',
            },
            {
              type: 'work_place_c',
              name: _.get(fieldItems, 'field_item_list3_title'),
              display: !!_.get(fieldItems, 'field_item_list3_display_flag'),
              index: 3,
              key: 'c',
            },
            {
              type: 'work_place_d',
              name: _.get(fieldItems, 'field_item_list4_title'),
              display: !!_.get(fieldItems, 'field_item_list4_display_flag'),
              index: 4,
              key: 'd',
            },
          ];
          columnHeader.splice(workPlaceIndex, 1, ...workPlace);
        }
        let pinnedColumn = SessionStorageService.getPinnedColumn();
        if (!SessionStorageService.getInitOrderColumn()) {
          SessionStorageService.setInitOrderColumn(columnHeader);
          SessionStorageService.setOrderColumn(columnHeader);
        } else {
          const initColumnHeader = SessionStorageService.getInitOrderColumn();
          const responseManHour = _.find(columnHeader, { type: 'man_hours' });
          const initManHour = _.find(initColumnHeader, { type: 'man_hours' });
          if (responseManHour && initManHour) {
            initManHour.name = responseManHour.name;
          }
          if (_.isEqual(initColumnHeader, columnHeader)) {
            columnHeader = SessionStorageService.getOrderColumn();
            const manHour = _.find(columnHeader, { type: 'man_hours' });
            if (manHour && responseManHour) {
              manHour.name = responseManHour.name;
            }
          } else {
            SessionStorageService.setPinnedColumn(0);
            pinnedColumn = 0;
            SessionStorageService.setOrderColumn(columnHeader);
            SessionStorageService.setInitOrderColumn(columnHeader);
          }
        }

        this.handleRequiredOption(columnHeader, fieldItems);
        this.setState({
          pinnedColumn,
          columnHeader,
          fieldItems,
          fieldInfo,
        });
      }
    });
  };

  initWorkCollectionView = async () => {
    const works = await this.getWorks();
    this.setState({
      workCollectionView: new CollectionView(works, {
        groupDescriptions: ['isPrivateWork'],
      }),
      isLoading: false,
    });
  };

  setWorkCollectionView = async () => {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    Loader.start();
    const works = await this.getWorks();
    const { workCollectionView } = this.state;
    workCollectionView.sourceCollection.push(...works);
    workCollectionView.refresh();
    this.isLoading = false;
    Loader.done();
  };

  /**
   * Handle set list required option item
   * @param { object } columnHeader
   * @param { object } fieldItems
   */
  handleRequiredOption = (columnHeader, fieldItems) => {
    _.each(columnHeader, column => {
      if (
        _.includes(this.optionListNumbers, column.type) &&
        fieldItems[`${column.type}_display_flag`] === API_FLAG.On
      ) {
        const key = `${column.type}_must_flag`;
        this.optionMustFlag[key] = _.get(fieldItems, key, 0);
      }
    });
  };

  componentWillUnmount() {
    this.toggleConferenceMode(false);
  }

  getWorks = async () => {
    const {
      scheduleFlag,
      selectedWorkIds,
      offset,
      fieldId,
      currentWorkTotal,
    } = this.state;
    const params = {
      schedule_flag: scheduleFlag,
      work_ids: selectedWorkIds[offset],
    };
    const response = await WorkScheduleService.getWorkByIds(fieldId, params);
    let works = [];
    if (response.result) {
      works = _.get(response, 'data.entities.works', []);
      const allLoaded = offset === _.size(selectedWorkIds) - 1;
      if (!allLoaded) {
        this.setState({ offset: offset + 1 });
      }
      this.setState({
        allLoaded,
        currentWorkTotal: currentWorkTotal + _.size(works),
      });
    }
    return this.tranFormData(works);
  };

  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  handleToggleModal = status => {
    this.setState({
      isVisibleUpdateModal: status,
      tabKeyStatus: status ? TAB_KEY_STATUS.disabled : TAB_KEY_STATUS.enabled,
    });
  };

  /**
   * Transform data for show in table list
   * @param works
   * @returns {*[]}
   */
  tranFormData = works => {
    const data = [];
    let tempWorkGroupImages = _.cloneDeep(this.state.tempWorkGroupImages);
    let messageValidate = _.cloneDeep(this.state.messageValidate);
    _.map(works, item => {
      const {
        work_date,
        nest_no,
        company_name_1,
        company_name,
        field_tree_id,
        job_name,
        job_id,
        foreman_user_id,
        foreman_user_name_mei,
        foreman_user_name_sei,
        partner_company_approval_flag,
        approved_flag,
        state_handling_flag,
      } = item.work_group;
      const partnerCompanyApprovalFlag =
        this.state.usePartnerCompanyApprovalFlag &&
        partner_company_approval_flag === API_FLAG.On;
      const approved = isApiFlagOn(approved_flag);
      const aborted = state_handling_flag;
      item.work_date = work_date;
      item.company_name =
        nest_no === 1 ? company_name : `${company_name_1}（${company_name}）`;
      item.field_tree_id = field_tree_id;
      item.job_name = job_name;
      item.job_id = job_id;
      item.foreman_user_id = foreman_user_id;
      item.foreman_user_name = `${foreman_user_name_sei} ${foreman_user_name_mei}`;
      item.manager_user_name = `${item.manager_user_name_sei} ${item.manager_user_name_mei}`;
      item.is_data_changed = {};
      item.work_key_plan_image = item.work_key_plan_image
        ? item.work_key_plan_image
        : {};
      item.isPrivateWork = this.state.selectedPrivateWorkIds.includes(item.id);
      item.tempWorkGroupId = item.work_group_id;
      item.isAbortedOrApproved =
        aborted || approved || partnerCompanyApprovalFlag;
      data.push(item);
      tempWorkGroupImages = this.setWorkKeyPlanImage(item, tempWorkGroupImages);
      messageValidate = this.handleValidate(item, messageValidate);
    });
    const showWorkDayworkersUnSolvableErrorMessage = this.shouldWorkDayworkersErrorMessage(
      this.state.columnHeader,
      messageValidate
    );
    this.setState({
      tempWorkGroupImages,
      messageValidate,
      showWorkDayworkersUnSolvableErrorMessage,
    });
    return data;
  };

  /**
   * BLDE_V2-48669: 「人工未入力エラー」かつ「人工が非表示」であるか判定する。
   * 人工カラムが非表示でありバリデーションエラーがあった場合、
   * 解決不能であり一覧表示設定の変更が必要なメッセージを出すべきとする。
   *
   * @param {boolean} columns 表示カラム情報
   * @param {Array} validationResults バリデーション実施結果の配列
   *
   * @return {boolean} true：メッセージ表示要、false：メッセージ表示不要
   */
  shouldWorkDayworkersErrorMessage = (columns, validationResults) => {
    if (_.find(columns, colum => colum.type === 'man_hours') !== undefined) {
      // 人工が表示設定なら追加メッセージは不要
      return false;
    }

    const workDayWorkerError = _.find(validationResults, validateObject =>
      _.has(validateObject.message, 'work_dayworkers')
    );
    // 人工エラーが出ていれば追加メッセージを表示
    return workDayWorkerError !== undefined;
  };

  /**
   * set tempWorkGroupImages when loaded work data form api
   * @param work
   * @param temWorkGroups
   * @returns {*}
   */
  setWorkKeyPlanImage = (work, temWorkGroups) => {
    const {
      work_group_id,
      id,
      work_key_plan_image,
      work_date,
      field_tree_id,
      job_id,
      foreman_user_id,
    } = work;

    const workGroupCondition = {
      work_date,
      field_tree_id,
      job_id,
      foreman_user_id,
    };
    const workGroups = _.clone(temWorkGroups);
    const index = _.findIndex(workGroups, item =>
      _.isEqual(item.workGroupCondition, workGroupCondition)
    );
    if (index > -1) {
      workGroups[index]['workIds'].push(id);
    } else {
      workGroups.push({
        workGroupId: work_group_id,
        recordEdited: null, // the record (id) edited key plan
        workIds: [id],
        workGroupImage: work_key_plan_image,
        workGroupImageTmp: {},
        workGroupCondition: {
          work_date,
          field_tree_id,
          job_id,
          foreman_user_id,
        },
      });
    }
    return workGroups;
  };

  /**
   * Initial Flex Grid wijimo
   * @param grid
   */
  initializeGrid = grid => {
    this.grid = grid;
    grid.rows.defaultSize = 60;
    grid.columnHeaders.rows.minSize = 30;

    //handle load more data
    grid.scrollPositionChanged.addHandler(s => {
      if (s.viewRange.bottomRow >= s.rows.length - 1 && !this.state.allLoaded) {
        let view = s.collectionView;
        if (view) {
          const index = view.currentPosition;
          this.setWorkCollectionView();
          view.refresh();
          view.currentPosition = index;
        }
      }
    });

    grid.itemFormatter = (panel, row, col, cell) => {
      const flex = panel.grid;
      // handle group private work and not private work
      if (panel.rows[row] instanceof wjGrid.GroupRow) {
        flex.rows[row].cssClassAll = 'group-row-custom';
        flex.rows[row].height = 30;
        const isPrivateGroup = flex.rows[row].dataItem.name === true;
        if (isPrivateGroup) {
          if (col === 0) {
            //first column
            cell.innerHTML = '以下、別途協力会社';
          }
        } else {
          flex.rows[row].visible = false;
        }
      } else if (panel === this.grid.cells) {
        // normal cells
        flex.rows[row].height = 60;
      }
    };

    //prevent selecting group row
    grid.selectionChanging.addHandler((sender, event) => {
      event.cancel = sender.rows[event.row] instanceof wjGrid.GroupRow;
    });
    const setPinnedColumn = (frozenColumns, lineNumberIndex) => {
      if (frozenColumns && frozenColumns < lineNumberIndex + 1) {
        SessionStorageService.setPinnedColumn(frozenColumns + 1);
      } else {
        SessionStorageService.setPinnedColumn(frozenColumns);
      }
    };
    grid.pinnedColumn.addHandler(sender => {
      const lineNumberIndex = _.findIndex(
        grid.columns,
        column => !column.binding
      );
      setPinnedColumn(sender.frozenColumns, lineNumberIndex);
    });
    grid.draggedColumn.addHandler(sender => {
      const newColumnHeader = [];
      let lineNumberIndex = 0;
      _.forEach(grid.columns, (column, index) => {
        const columnBinding = JSON.parse(column.binding);
        if (columnBinding) {
          newColumnHeader.push(columnBinding);
        } else {
          lineNumberIndex = index;
        }
      });
      setPinnedColumn(sender.frozenColumns, lineNumberIndex);
      SessionStorageService.setOrderColumn(newColumnHeader);
    });
    this.setState({ isInitializedGrid: true });
  };

  /**
   * Handle push param for update when change data
   * @param item
   * @param name
   * @returns {Promise<void>}
   */
  handlePushParam = async (item, name = '') => {
    let messageValidate = _.cloneDeep(this.state.messageValidate);
    messageValidate = this.handleValidate(item, messageValidate);
    const itemChanged = _.cloneDeep(this.state.itemChanged);
    if (
      _.includes(
        ['work_date', 'field_tree_id', 'foreman_user_id', 'job_id'],
        name
      )
    ) {
      this.handleUpdateKeyPlanImage(item);
    }
    const index = _.findIndex(itemChanged, i => i.id === item.id);
    if (index > -1) {
      itemChanged[index] = item;
    } else {
      itemChanged.push(item);
    }
    this.setState({ itemChanged, messageValidate });
  };

  /**
   * Handle change key plan and key plan image when work group change
   * @param data
   * @returns {Promise<void>}
   */
  handleUpdateKeyPlanImage = async data => {
    const {
      work_date,
      field_tree_id,
      foreman_user_id,
      job_id,
      id,
      tempWorkGroupId,
    } = data;

    if (foreman_user_id && job_id && field_tree_id && work_date) {
      const tempWorkGroupImages = _.cloneDeep(this.state.tempWorkGroupImages);
      const workGroupCondition = {
        work_date,
        field_tree_id,
        job_id,
        foreman_user_id,
      };
      // find tempWorkGroupImages in current state ( client );
      const workGroupImage = _.find(tempWorkGroupImages, item =>
        _.isEqual(item.workGroupCondition, workGroupCondition)
      );

      // find current temp work group image of work;
      const currentWorkGroupImage = _.find(tempWorkGroupImages, [
        'workGroupId',
        tempWorkGroupId,
      ]);

      const currentWorkIds = _.get(currentWorkGroupImage, 'workIds');
      // if array workIds > 1 => remove workId else remove current temp work group image;
      if (_.size(currentWorkIds) > 1) {
        if (currentWorkGroupImage['recordEdited'] === id) {
          currentWorkGroupImage['recordEdited'] = null;
        }
        _.remove(currentWorkIds, currentId => currentId === id);
        currentWorkGroupImage['workIds'] = currentWorkIds;
        currentWorkGroupImage['workGroupImageTmp'] = {};
      } else {
        _.remove(
          tempWorkGroupImages,
          currentWorkGroup => currentWorkGroup.workGroupId === tempWorkGroupId
        );
      }

      if (workGroupImage) {
        const v = this.grid.collectionView;
        v.editItem(v.currentItem);
        v.currentItem['tempWorkGroupId'] = tempWorkGroupImages.groupId;
        workGroupImage['workIds'].push(id);
        v.commitEdit();
        return this.setState({ tempWorkGroupImages });
      }

      const responseData = await this.getKeyPlanImage(data);
      const keyPlanImage = {
        edited_image: null,
        layout_json: null,
        img_url: '',
        key_plan_category_code: null,
        key_plan_name: '',
      };
      let groupId = _.uniqueId('temp_work_id_');
      if (responseData) {
        const {
          key_plan_category_code,
          key_plan_name,
          img_url,
          field_image_url,
          layout_json,
          work_group_id,
        } = responseData;
        keyPlanImage['layout_json'] = !_.isEmpty(layout_json)
          ? JSON.parse(layout_json)
          : null;
        keyPlanImage['img_url'] = img_url ? img_url : field_image_url;
        keyPlanImage['key_plan_category_code'] = key_plan_category_code;
        keyPlanImage['key_plan_name'] = key_plan_name || '';
        groupId = work_group_id;
      }
      tempWorkGroupImages.push({
        workGroupId: groupId,
        workIds: [id],
        recordEdited: id, // the record (id) edited key plan
        workGroupImageTmp: {},
        workGroupImage: keyPlanImage,
        workGroupCondition,
      });
      // set data changed
      const v = this.grid.collectionView;
      v.editItem(v.currentItem);
      v.currentItem['tempWorkGroupId'] = groupId;
      if (!v.currentItem['is_data_changed']['work_key_plan_code']) {
        v.currentItem['is_data_changed']['work_key_plan_code'] = true;
      }
      if (!v.currentItem['is_data_changed']['work_key_plan_image']) {
        v.currentItem['is_data_changed']['work_key_plan_image'] = true;
      }
      v.commitEdit();
      this.setState({ tempWorkGroupImages });
    }
  };

  /**
   * get key plane image with condition work group
   * @param data
   * @returns {Promise<any|null>}
   */
  getKeyPlanImage = async data => {
    const {
      work_date,
      field_tree_id,
      foreman_user_id,
      job_id,
      work_group: { work_hour_zone },
    } = data;
    const response = await WorkScheduleService.getKeyPlanImage({
      fieldId: this.state.fieldId,
      fieldTreeId: field_tree_id,
      foremanUserId: foreman_user_id,
      jobId: job_id,
      workDate: work_date,
      workHourZone: work_hour_zone,
      scheduleFlag: this.state.scheduleFlag,
    });

    return _.get(response, 'data.entities.work_key_plan_image') || null;
  };

  isRequiredMainSubWork = date => {
    const progressDateFrom = moment(this.state.progressDateFrom);
    const progressDateTo = moment(this.state.progressDateTo);
    const workDate = moment(date);
    let isRequired = true;
    if (
      !progressDateFrom.isValid() ||
      (!progressDateTo.isValid() && workDate.isBefore(progressDateFrom)) ||
      workDate.isBefore(progressDateFrom) ||
      progressDateTo.isBefore(workDate) ||
      this.state.lengthOfListMainWorkTypes === 0
    ) {
      isRequired = false;
    }
    return isRequired;
  };

  handleValidate = (item, messageValidate) => {
    const dataValidate = _.cloneDeep({ ...item, ...this.optionMustFlag });
    if (!this.isRequiredMainSubWork(dataValidate.work_date)) {
      dataValidate.required_item_list_ids = [];
    }
    _.each(Object.keys(dataValidate), key => {
      if (
        (_.isNull(dataValidate[key]) || dataValidate[key] === '') &&
        key !== 'required_item_list_ids'
      ) {
        dataValidate[key] = undefined;
      }
    });
    const rs = validationByJoi(this.workSchema, dataValidate);
    const index = _.findIndex(messageValidate, ['work_id', item.id]);
    if (index > -1) {
      if (!_.isEmpty(item['is_data_changed'])) {
        _.forEach(item['is_data_changed'], (value, key) => {
          if (!value) {
            rs.messages[key] = messageValidate[index].message[key];
          }
        });
      }
      messageValidate.splice(index, 1);
    }
    if (_.isEmpty(item['work_dayworkers'])) {
      rs.messages['work_dayworkers'] = messageUtility.getMessage('E-000-010');
    }
    if (!_.isEmpty(rs.messages)) {
      messageValidate.push({
        work_id: item.id,
        message: rs.messages,
      });
    }
    return messageValidate;
  };

  handleTransformParams = data => {
    const { tempWorkGroupImages } = this.state;
    return _.map(data, item => {
      const workKeyPlanImage = {
        is_not_update: true,
        edited_image: null,
        layout_json: null,
      };
      const workGroup = _.find(tempWorkGroupImages, tempWorkGroup =>
        _.isEqual(tempWorkGroup.workGroupCondition, {
          work_date: item.work_date,
          field_tree_id: item.field_tree_id,
          job_id: item.job_id,
          foreman_user_id: item.foreman_user_id,
        })
      );
      if (workGroup && workGroup.recordEdited === item.id) {
        workKeyPlanImage.is_not_update = false;
        workKeyPlanImage.layout_json = _.get(
          workGroup,
          'workGroupImage.layout_json',
          null
        );
        workKeyPlanImage.edited_image = _.get(
          workGroup,
          'workGroupImage.edited_image',
          null
        );
        workKeyPlanImage.key_plan_category_code = _.get(
          workGroup,
          'workGroupImage.key_plan_category_code',
          null
        );
        if (!_.isEmpty(workGroup.workGroupImageTmp)) {
          workKeyPlanImage.layout_json = _.get(
            workGroup,
            'workGroupImageTmp.layout_json',
            null
          );
          workKeyPlanImage.edited_image = _.get(
            workGroup,
            'workGroupImageTmp.edited_image',
            null
          );
          workKeyPlanImage.key_plan_category_code = _.get(
            workGroup,
            'workGroupImageTmp.key_plan_category_code',
            null
          );
        }
      }
      const paramItem = {};
      paramItem.id = item.id;
      paramItem.work_date = _.get(item, 'work_date', null);
      paramItem.field_tree_id = _.get(item, 'field_tree_id', null);
      paramItem.job_id = _.get(item, 'job_id', null);
      paramItem.foreman_user_id = _.get(item, 'foreman_user_id', null);
      paramItem.a_item_id = _.get(item, 'a_item_id', null);
      paramItem.b_item_id = _.get(item, 'b_item_id', null);
      paramItem.c_item_id = _.get(item, 'c_item_id', null);
      paramItem.d_item_id = _.get(item, 'd_item_id', null);
      paramItem.contents = _.get(item, 'contents', '');
      paramItem.safety_instruction = _.get(item, 'safety_instruction', null);
      paramItem.note = _.get(item, 'note', '');
      paramItem.memo = _.get(item, 'memo', '');
      paramItem.hot_work_code = _.get(item, 'hot_work_code', null);
      paramItem.hot_work_start = _.get(item, 'hot_work_start', null);
      paramItem.hot_work_end = _.get(item, 'hot_work_end', null);
      paramItem.oxygen_lack_dangerous_work_upper = _.get(
        item,
        'oxygen_lack_dangerous_work_upper',
        ''
      );
      paramItem.oxygen_lack_dangerous_work_lower = _.get(
        item,
        'oxygen_lack_dangerous_work_lower',
        ''
      );
      paramItem.oxygen_lack_education_complete_upper = _.get(
        item,
        'oxygen_lack_education_complete_upper',
        ''
      );
      paramItem.oxygen_lack_education_complete_lower = _.get(
        item,
        'oxygen_lack_education_complete_lower',
        ''
      );
      paramItem.manager_user_id = _.get(item, 'manager_user_id', null);
      paramItem.dayworker_type = _.get(item, 'dayworker_type', null);
      paramItem.groups = _.get(item, 'groups', '');
      paramItem.main_work_type_id = _.get(item, 'main_work_type_id', null);
      paramItem.sub_work_type_id = _.get(item, 'sub_work_type_id', null);
      paramItem.display_fifteen_minute_flg = _.get(
        item,
        'display_fifteen_minute_flg',
        null
      );
      paramItem.work_dayworkers = _.get(item, 'work_dayworkers', null);
      paramItem.woman = _.get(item, 'woman', null);
      paramItem.non_japanese = _.get(item, 'non_japanese', null);
      paramItem.work_early_times = _.get(item, 'work_early_times', null);
      paramItem.work_over_times = _.get(item, 'work_over_times', null);
      paramItem.work_key_plan_image = workKeyPlanImage;
      paramItem.from_work_edit = 1;
      paramItem.work_hour_zone = _.get(item, 'work_group.work_hour_zone', null);
      for (let i = 1; i <= 20; i++) {
        paramItem[`option${i}`] = _.get(item, `option${i}`, '');
      }
      paramItem.work_dayworkers_changed_flag = _.get(
        item,
        'is_data_changed.work_dayworkers',
        false
      );
      return paramItem;
    });
  };

  handleSplitRequest = () => {
    const data = _.chunk(_.clone(this.state.itemChanged), 100);
    const { fieldId, scheduleFlag } = this.state;
    const requestApi = [];
    _.each(data, params => {
      requestApi.push(
        WorkScheduleService.multipleUpdateWork(fieldId, {
          field_id: fieldId,
          schedule_flag: scheduleFlag,
          works: this.handleTransformParams(params),
        })
      );
    });
    return requestApi;
  };

  handleUpdateWorks = async () => {
    if (this.isSubmittingFlag) {
      return;
    }
    this.isSubmittingFlag = true;
    const updatedWorkIds = [];
    const workNotFoundIds = [];
    const workErrors = [];
    Promise.all(this.handleSplitRequest())
      .then(async responses => {
        let hasDuplicateTransmissionError = false;
        _.each(responses, response => {
          const data = _.get(response, 'data.entities', {});
          updatedWorkIds.push(...(data.updated_work_ids || []));
          workNotFoundIds.push(...(data.work_not_found_ids || []));
          workErrors.push(...(data.work_errors || []));
          if (!hasDuplicateTransmissionError && isDuplicateTransmissionError(response)) {
            hasDuplicateTransmissionError = true;
          }
        });

        const totalSuccess = _.size(updatedWorkIds);
        const totalNotFound = _.size(workNotFoundIds);
        const totalFail = _.size(workErrors);

        if (totalFail > 0) {
          this.handleProgressFieldSetting();
          this.handleSetWorkCollectionView(
            [...updatedWorkIds, ...workNotFoundIds],
            workErrors
          );
          this.setState({
            messageValidate: workErrors,
            itemChanged: [],
          });
        }

        if (hasDuplicateTransmissionError) {
          return dialogLoader.show(FormInformationDialog, {
            message: messageUtility.getMessage('E-000-052'),
            onClose: () => {
              dialogLoader.close();
            },
            buttonText: messageUtility.getMessage('I-000-008'),
            buttonClassName: 'btn--sm--sub',
            multilineText: false,
          });
        }
        if (totalFail === 0 && totalNotFound === 0) {
          return this.renderPopupError(totalSuccess, totalNotFound, totalFail);
        }
        return this.renderPopupError(totalSuccess, totalNotFound, totalFail);
      })
      .finally(() => {
        this.isSubmittingFlag = false;
        this.handleToggleModal(false);
      });
  };

  handleSetWorkCollectionView = (listIdsToRemove, workErrors) => {
    const { _src } = this.grid.itemsSource;
    const works = _.filter(_src, item => !listIdsToRemove.includes(item.id));
    const workErrorIds = _.map(workErrors, workError => workError.work_id);
    _.forEach(works, work => {
      if (_.includes(workErrorIds, work.id)) {
        const workError = _.find(workErrors, item => item.work_id === work.id);
        _.forEach(workError.message, (value, key) => {
          work['is_data_changed'][key] = false;
        });
      }
    });
    const tempWorkGroupImages = _.cloneDeep(this.state.tempWorkGroupImages);

    const newTempWorkGroupImages = [];
    _.forEach(tempWorkGroupImages, (group, index) => {
      tempWorkGroupImages[index]['workIds'] = _.filter(
        group.workIds,
        workId => !_.includes(listIdsToRemove, workId)
      );
      if (!_.isEmpty(tempWorkGroupImages[index].workIds)) {
        newTempWorkGroupImages.push(tempWorkGroupImages[index]);
      }
    });

    const workCollectionView = new CollectionView(works, {
      groupDescriptions: ['isPrivateWork'],
    });
    this.setState({ isLoading: true, currentWorkTotal: 0 });
    this.setState(
      {
        workCollectionView,
        tempWorkGroupImages: newTempWorkGroupImages,
      },
      () =>
        this.setState({
          isLoading: false,
          currentWorkTotal: _.size(works),
        })
    );
  };

  getMessageError = (totalSuccess, totalNotFound, totalFail, screen) => {
    const listMessages = [];
    if (totalSuccess) {
      listMessages.push(`${totalSuccess}件の作業${screen}を更新完了しました。`);
    }
    if (totalNotFound) {
      listMessages.push(`${totalNotFound}件の作業${screen}は削除されました。`);
    }
    if (totalFail) {
      listMessages.push(
        `${totalFail}件の作業${screen}はエラーが発生したため、更新できませんでした。`
      );
      listMessages.push(
        `エラー内容を確認してから、入力内容を見直してください。`
      );
    }
    return listMessages.join('\n');
  };

  renderPopupError = (totalSuccess, totalNotFound, totalFail) => {
    const screen = this.props.isWorkSchedule ? '予定' : '実績';
    return dialogLoader.show(FormInformationDialog, {
      title: `作業${screen}の一括編集`,
      message: this.getMessageError(
        totalSuccess,
        totalNotFound,
        totalFail,
        screen
      ),
      rootClassName: 'dialog--wide',
      onClose: () => {
        if (totalFail) {
          dialogLoader.close();
        } else {
          this.GoBack.callback.clear();
        }
      },
    });
  };

  renderWorkList = () => {
    const {
      columnHeader,
      workCollectionView,
      fieldItems,
      fieldInfo,
      tabKeyStatus,
      isInitializedGrid,
    } = this.state;
    const { isWorkSchedule } = this.props;
    return (
      <FlexGrid
        itemsSource={isInitializedGrid ? workCollectionView : []}
        selectionMode='Cell'
        showMarquee={true}
        stickyHeaders={true}
        allowSorting={false}
        allowPinning='ColumnRange'
        validateEdits={false}
        showErrors={false}
        initialized={this.initializeGrid}
        headersVisibility='Column'
        cloneFrozenCells={false}
        frozenColumns={this.state.pinnedColumn}
      >
        <FlexGridColumn
          width={80}
          cssClassAll={'wi-text-white wi-bg-black'}
          isReadOnly={true}
        >
          <FlexGridCellTemplate
            cellType='ColumnHeader'
            template={ctx => <HeaderTemplate context={ctx} name='行番号' />}
          />
          <FlexGridCellTemplate
            cellType='Cell'
            isReadOnly={true}
            template={ctx => (
              <HeaderRowTemplate
                context={ctx}
                msgValidate={this.state.messageValidate}
              />
            )}
          />
        </FlexGridColumn>
        {_.map(columnHeader, item => {
          switch (item.type) {
            case 'work_date':
              return (
                <FlexGridColumn
                  width={155}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        isRequired={true}
                        name={item.name}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    isReadOnly={true}
                    template={ctx => (
                      <WorkDateTemplate
                        msgValidate={this.state.messageValidate}
                        handlePushParam={this.handlePushParam}
                        grid={this.grid}
                        context={ctx}
                        fieldInfo={fieldInfo}
                        column={item.type}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'company_name':
              return (
                <FlexGridColumn
                  width={200}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        isRequired={true}
                        name={item.name}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    isReadOnly={true}
                    template={ctx => (
                      <PartnerCompanyTemplate
                        msgValidate={this.state.messageValidate}
                        handlePushParam={this.handlePushParam}
                        grid={this.grid}
                        context={ctx}
                        column={item.type}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'job_name':
              return (
                <FlexGridColumn
                  width={200}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        isRequired={true}
                        name={item.name}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    isReadOnly={false}
                    template={ctx => (
                      <JobTemplate
                        msgValidate={this.state.messageValidate}
                        handlePushParam={this.handlePushParam}
                        grid={this.grid}
                        context={ctx}
                        column={item.type}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'foreman_user_name':
              return (
                <FlexGridColumn
                  width={200}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        isRequired={true}
                        name={item.name}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <ForemanTemplate
                        msgValidate={this.state.messageValidate}
                        handlePushParam={this.handlePushParam}
                        grid={this.grid}
                        context={ctx}
                        column={item.type}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'work_place_a':
            case 'work_place_b':
            case 'work_place_c':
            case 'work_place_d':
              return (
                !!fieldItems[`field_item_list${item.index}_display_flag`] && (
                  <FlexGridColumn
                    cssClassAll={'wi-text-white wi-bg-black'}
                    width={200}
                    key={item.type}
                    isReadOnly={true}
                    binding={JSON.stringify(item)}
                    header={item.name}
                  >
                    <FlexGridCellTemplate
                      cellType='ColumnHeader'
                      template={ctx => (
                        <HeaderTemplate context={ctx} name={item.name} />
                      )}
                    />
                    <FlexGridCellTemplate
                      cellType='Cell'
                      isReadOnly={false}
                      template={ctx => (
                        <FieldItemTemplate
                          title={`${item.name}を選択`}
                          msgValidate={this.state.messageValidate}
                          handlePushParam={this.handlePushParam}
                          grid={this.grid}
                          context={ctx}
                          fieldItemType={item.key}
                          numberOfPlace={item.index}
                          column={item.type}
                        />
                      )}
                    />
                  </FlexGridColumn>
                )
              );
            case 'man_hours':
              return (
                <FlexGridColumn
                  cssClassAll={'wi-text-white wi-bg-black'}
                  width={148}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        name={item.name}
                        isRequired={true}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    isReadOnly={true}
                    template={ctx => (
                      <WorkDayWorkerTemplate
                        grid={this.grid}
                        context={ctx}
                        handlePushParam={this.handlePushParam}
                        isWorkSchedule={isWorkSchedule}
                        fieldInfo={fieldInfo}
                        msgValidate={this.state.messageValidate}
                        column={item.type}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'print_groups':
              return (
                <FlexGridColumn
                  width={170}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  key={item.type}
                  isReadOnly={true}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate context={ctx} name={item.name} />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    isReadOnly={true}
                    template={ctx => (
                      <GroupsTemplate
                        msgValidate={this.state.messageValidate}
                        handlePushParam={this.handlePushParam}
                        grid={this.grid}
                        context={ctx}
                        column={item.type}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'oxygen_lack':
              if (fieldItems.oxygen_lack_print_flag === 0) {
                return null;
              }
              return (
                <FlexGridColumn
                  width={148}
                  isReadOnly={true}
                  key={item.type}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate context={ctx} name={item.name} />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <OxygenLackTemplate
                        grid={this.grid}
                        context={ctx}
                        handlePushParam={this.handlePushParam}
                        msgValidate={this.state.messageValidate}
                        column={item.type}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'manager_user_name':
              return (
                <FlexGridColumn
                  width={200}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate context={ctx} name={item.name} />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <ManagerUserTemplate
                        grid={this.grid}
                        context={ctx}
                        handlePushParam={this.handlePushParam}
                        msgValidate={this.state.messageValidate}
                        column={item.type}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'hot_work':
              return (
                <FlexGridColumn
                  width={148}
                  isReadOnly={true}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate context={ctx} name={item.name} />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <HotWorkTemplate
                        grid={this.grid}
                        context={ctx}
                        handlePushParam={this.handlePushParam}
                        msgValidate={this.state.messageValidate}
                        column={item.type}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'key_plan_name':
              return (
                <FlexGridColumn
                  width={290}
                  isReadOnly={true}
                  cssClassAll={'wi-text-white wi-bg-black'}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate context={ctx} name={item.name} />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <KeyPlanTemplate
                        grid={this.grid}
                        handlePushParam={this.handlePushParam}
                        tempWorkGroupImages={this.state.tempWorkGroupImages}
                        context={ctx}
                        column={item.type}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            case 'contents':
              return (
                <FlexGridColumn
                  cssClassAll={'wi-text-white wi-bg-black'}
                  width={400}
                  isReadOnly={true}
                  key={item.type}
                  binding={JSON.stringify(item)}
                  header={item.name}
                >
                  <FlexGridCellTemplate
                    cellType='ColumnHeader'
                    template={ctx => (
                      <HeaderTemplate
                        context={ctx}
                        name={item.name}
                        isRequired={true}
                      />
                    )}
                  />
                  <FlexGridCellTemplate
                    cellType='Cell'
                    template={ctx => (
                      <ContentTemplate
                        msgValidate={this.state.messageValidate}
                        grid={this.grid}
                        column='contents'
                        handlePushParam={this.handlePushParam}
                        context={ctx}
                        maxLength={255}
                        tabKeyStatus={tabKeyStatus}
                      />
                    )}
                  />
                </FlexGridColumn>
              );
            default:
              if (this.optionListNumbers.includes(item.type)) {
                if (fieldItems[`${item.type}_display_flag`] === API_FLAG.On) {
                  return (
                    <FlexGridColumn
                      cssClassAll={'wi-text-white wi-bg-black'}
                      width={
                        fieldItems[`${item.type}_history_flag`] ? 360 : 250
                      }
                      isReadOnly={true}
                      key={item.type}
                      binding={JSON.stringify(item)}
                      header={fieldItems[`${item.type}_title`]}
                    >
                      <FlexGridCellTemplate
                        cellType='ColumnHeader'
                        template={ctx => (
                          <HeaderTemplate
                            context={ctx}
                            isRequired={
                              fieldItems[`${item.type}_must_flag`] ===
                              API_FLAG.On
                            }
                            name={fieldItems[`${item.type}_title`]}
                          />
                        )}
                      />
                      <FlexGridCellTemplate
                        cellType='Cell'
                        template={ctx => (
                          <OptionTemplate
                            isShowHistory={
                              fieldItems[`${item.type}_history_flag`]
                            }
                            grid={this.grid}
                            column={item.type}
                            context={ctx}
                            handlePushParam={this.handlePushParam}
                            msgValidate={this.state.messageValidate}
                            maxLength={
                              _.includes(WORK_LIST_FIRST_3_ITEMS, item.type)
                                ? FIXED_ITEM_MAX_LENGTH
                                : ITEM_MAX_LENGTH
                            }
                            tabKeyStatus={tabKeyStatus}
                          />
                        )}
                      />
                    </FlexGridColumn>
                  );
                }
                return null;
              } else {
                return (
                  <FlexGridColumn
                    width={210}
                    cssClassAll={'wi-text-white wi-bg-black'}
                    isReadOnly={true}
                    key={item.type}
                    binding={JSON.stringify(item)}
                    header={item.name}
                  >
                    <FlexGridCellTemplate
                      cellType='ColumnHeader'
                      template={() => <HeaderTemplate name={item.name} />}
                    />
                    <FlexGridCellTemplate
                      cellType='Cell'
                      template={ctx => (
                        <InputTemplate
                          handlePushParam={this.handlePushParam}
                          grid={this.grid}
                          column={item.type}
                          context={ctx}
                          maxLength={31}
                          msgValidate={this.state.messageValidate}
                          tabKeyStatus={tabKeyStatus}
                        />
                      )}
                    />
                  </FlexGridColumn>
                );
              }
          }
        })}
      </FlexGrid>
    );
  };

  countTotalErrorMessage = () => {
    let total = 0;
    _.each(this.state.messageValidate, msg => {
      total += _.size(msg.message);
    });
    return total;
  };

  renderNote = () => {
    return (
      <div className='WorkMultipleEdit__note'>
        <div className='WorkMultipleEdit__note-content'>
          <span className='WorkMultipleEdit__note--bg WorkMultipleEdit__note--bg-yellow' />
          <span className='WorkMultipleEdit__note--text'>編集後の項目</span>
        </div>
      </div>
    );
  };

  renderMenu = () => {
    const isDisabledSubmitBtn =
      !_.isEmpty(this.state.messageValidate) ||
      _.isEmpty(this.state.itemChanged);
    const { tabKeyStatus } = this.state;
    return (
      <ul className='btn-menu'>
        <li className='btn-menu__item'>
          <button
            className='btn--sub'
            onClick={this.handleGoBackDialog}
            tabIndex={tabKeyStatus}
          >
            編集をやめる
          </button>
        </li>
        <li className='btn-menu__item'>
          <button
            className={
              isDisabledSubmitBtn
                ? 'btn--effective btn--disabled'
                : 'btn--effective'
            }
            disabled={isDisabledSubmitBtn}
            onClick={() => this.handleToggleModal(true)}
            tabIndex={tabKeyStatus}
          >
            更新
          </button>
        </li>
        <li className='btn-menu__item text-warning'>
          {messageUtility.getMessage('I-001-509')}
        </li>
      </ul>
    );
  };

  renderError = () => {
    return (
      this.countTotalErrorMessage() > 0 && (
        <React.Fragment>
          <div className='text-error'>
            エラーが{this.countTotalErrorMessage()}
            件あります。入力内容を確認してください。
          </div>
          {this.state.showWorkDayworkersUnSolvableErrorMessage && (
            <div>
              <div className='text-error'>
                入力必須項目「人工」が非表示になっています。非表示の項目が未入力なため保存できませんでした。
              </div>
              <div className='text-error'>
                表示項目の設定変更は、本社管理者または支店管理者が「一覧表示設定」で行うことができます。
              </div>
            </div>
          )}
        </React.Fragment>
      )
    );
  };

  render() {
    const { isWorkSchedule } = this.props;
    const {
      isLoading,
      currentWorkTotal,
      columnHeader,
      itemChanged,
    } = this.state;
    return (
      <div id='main' className='main'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - 作業
            {isWorkSchedule ? `予定` : `実績`}
            一括編集
          </title>
        </Helmet>

        <ConferencePageHeader
          title={`作業${isWorkSchedule ? `予定` : `実績`}一括編集`}
          onClose={this.handleGoBackDialog}
        />

        <div className='main__body CustomFlexGrid'>
          <div id='scrolll-parent' className='WorkMultipleEdit'>
            <div className='WorkMultipleEdit__header'>
              <div className='WorkMultipleEdit__header__menu'>
                {this.renderMenu()}
                {this.renderError()}
              </div>
              {this.renderNote()}
            </div>
            {currentWorkTotal > 0 &&
              !_.isEmpty(columnHeader) &&
              !isLoading &&
              this.renderWorkList()}
            <div className=''>
              <div>
                {isLoading && currentWorkTotal === 0 && (
                  <div className='indicator' />
                )}
                {!isLoading && currentWorkTotal === 0 && (
                  <div className='table-has-no-data'>
                    <div className='table-has-no-data__message'>
                      {messageUtility.getMessage('I-000-005')}
                    </div>
                  </div>
                )}
                {!isLoading && _.isEmpty(columnHeader) && (
                  <div className='table-has-no-data'>
                    <div className='table-has-no-data__message'>
                      {messageUtility.getMessage('I-000-224')}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Confirmation
          visible={this.state.isVisibleUpdateModal}
          title={`作業${this.props.isWorkSchedule ? '予定' : '実績'}一括更新`}
          message={
            <React.Fragment>
              <p>
                {_.size(itemChanged)}件の作業
                {this.props.isWorkSchedule ? '予定' : '実績'}
                の一括更新を行います。
              </p>
              <p>この内容で更新してよろしいですか？</p>
            </React.Fragment>
          }
          confirmButtonText={messageUtility.getMessage('I-000-088')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          onConfirm={this.handleUpdateWorks}
          onCancel={() => this.handleToggleModal(false)}
        />
      </div>
    );
  }
}

export default WorkBatchEdit;



// WEBPACK FOOTER //
// ./src/pages/WorkMultipleEdit.jsx